import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableSchoolyear } from '@teetsh/app/src/types/schoolyear';

export const SCHOOLYEARS_TRASH_KEY = 'schoolyears_trash';

function fetchSchoolyearsTrash() {
  const requestURL = '/schoolyears/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableSchoolyear[] }) => data || []);
}

export function useSchoolyearsTrash() {
  return useQuery({
    queryKey: [SCHOOLYEARS_TRASH_KEY],
    queryFn: () => fetchSchoolyearsTrash(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
